import TweenLite from 'TweenLite';
import Power2 from 'TweenLite';
import 'cssPlugin';

const heightAnimate = (el, duration = 0.3, action = 'open', delay = 0) => {
	const options = {
		height: 0,
		opacity: 0,
		ease: Power2.easeOut,
		delay
	};
	if (action === 'open') {
		TweenLite.set(el, {height: 'auto'});
		TweenLite.from(el, duration, options);
		TweenLite.to(el, duration, {
			opacity: 1,
			ease: Power2.easeOut,
			delay
		});
	} else {
		TweenLite.to(el, duration, options);
	}
};

const heightToggle = (el, stateOpen, content = el, duration = 0.4) => {
	const isOpen = el.hasClass(stateOpen);
	if (isOpen) {
		heightAnimate(content, duration, 'close');
	} else {
		heightAnimate(content, duration);
	}
};

export default heightAnimate;
export {heightToggle};



/** WEBPACK FOOTER **
 ** ./app/scripts/util/animate/heightAnimate.js
 **/